/** Contenido de UI por idioma (servicios, landing, auth, reservas, etc.) */

import imgAlineadores from '../Pages/images/img_tratamientos/alineadores-512x512.png';
import imgBracketsEsteticos from '../Pages/images/img_tratamientos/bracketsEsteticos-512x512.png';
import imgBracketsMetalicos from '../Pages/images/img_tratamientos/brackets-metalicos-512x512.png';
import imgMicroImplante from '../Pages/images/img_tratamientos/micro-implante-512x512.png';
import imgBracketsAutoligantes from '../Pages/images/img_tratamientos/brackets-autoligantes.png';
import imgKlammt from '../Pages/images/img_tratamientos/KLAMMT.png';
import imgBimler from '../Pages/images/img_tratamientos/BIMLER.png';
import imgPlanas from '../Pages/images/img_tratamientos/PLANAS.png';
import imgStockfisch from '../Pages/images/img_tratamientos/STOCKFISCH.png';
import imgClarkTwinBlock from '../Pages/images/img_tratamientos/CLARK.png';
import imgOrtopediaMaxilar from '../Pages/images/img_tratamientos/ortopedia-maxilar-512x512.png';
import imgRetenedores from '../Pages/images/img_tratamientos/retenedores-512x512.png';

const SERVICE_IMAGES = {
  1: imgBracketsMetalicos,
  5: 'https://d3t5ai5vcxyqte.cloudfront.net/media/pegjpxeakmijzlnklbubfsfun.svg',
  12: imgAlineadores,
  13: imgOrtopediaMaxilar,
  14: imgRetenedores,
  15: imgMicroImplante,
  16: imgBracketsEsteticos,
  17: imgBracketsAutoligantes,
  21: imgKlammt,
  22: imgBimler,
  23: imgPlanas,
  24: imgStockfisch,
  25: imgClarkTwinBlock,
};

/** Tratamientos cuyo icono es foto PNG (sin filtro azul de SVG). */
export const SERVICE_IMAGE_PHOTO_IDS = new Set([1, 12, 13, 14, 15, 16, 17, 21, 22, 23, 24, 25]);

export const siteContentEs = {
  services: {
    header: 'Nuestros Tratamientos',
    treatmentUnspecified: 'Tratamiento no indicado',
    bookingTreatments: [
      { id: 'primera-cita', title: 'Primera cita / Evaluación ortodóncica', shortTitle: 'Primera cita' },
      { id: 'metalBraces', title: 'Brackets metálicos', shortTitle: 'Brackets metálicos' },
      { id: 'ceramicBraces', title: 'Brackets estéticos', shortTitle: 'Brackets estéticos' },
      { id: 'invisalign', title: 'Invisalign / Alineadores', shortTitle: 'Alineadores' },
      { id: 'selfLigatingBraces', title: 'Brackets autoligantes', shortTitle: 'Brackets autoligantes' },
      { id: 'retainers', title: 'Retenedores', shortTitle: 'Retenedores' },
      { id: 'miniImplants', title: 'Microimplantes ortodóncicos', shortTitle: 'Microimplantes' },
      { id: 'thirdMolar', title: 'Cirugía de 3er molar', shortTitle: '3er molar' },
    ],
  },
  about: {
    title: 'Ortodoncia Dr. Germán Paniura en Cusco',
    shortDesc:
      'Soy el Dr. Germán Paniura, ortodoncista en Cusco. Dirijo Smile Up: brackets, Invisalign, ortopedia maxilar, retenedores y microimplantes, con una evaluación clara desde tu primera consulta conmigo.',
    longDesc:
      'Como especialista en ortodoncia atiendo brackets metálicos y estéticos, alineadores transparentes Invisalign, ortopedia maxilar para niños y adolescentes, retenedores y microimplantes cuando tu caso lo requiere. También coordino cirugía de terceros molares si forma parte de tu plan. En Cusco reviso tu mordida, simetría facial y hábitos; te explico el diagnóstico sin tecnicismos, las opciones y los tiempos reales. Mi objetivo es que entiendas cada paso, avances con comodidad y logres una sonrisa armónica con mi seguimiento cercano.',
    imageAlt: 'Dr. Germán Paniura — ortodoncia en Cusco',
  },
  contact: {
    scheduleTitle: 'Horarios',
    days: [
      { day: 'Lunes', time: '10:00–19:00' },
      { day: 'Martes', time: '10:00–19:00' },
      { day: 'Miércoles', time: '10:00–19:00' },
      { day: 'Jueves', time: '10:00–19:00' },
      { day: 'Viernes', time: '10:00–19:00' },
      { day: 'Sábado', time: '9:00–14:00' },
    ],
    directions: 'Dirección de la clínica',
    callClinic: 'Llamar a la clínica',
    whatsappCta: 'WhatsApp',
    mapTitle: 'Mapa de Smile Up en Cusco',
    socialAria: 'Redes sociales',
  },
  footer: {
    patientTitle: 'Área paciente',
    patientSubtitle: 'Accede a tu historial y citas',
    patientLogin: 'Paciente sesión',
    phoneLabel: 'Llamar:',
    phoneValue: '(084) 607539 - Peru',
    address: 'Av. La Cultura 822, Wanchaq-Cusco',
    seoLinksAria: 'Enlaces útiles',
    emergency: 'Dentista de emergencia en Cusco (EN)',
    libro: 'Libro de Reclamaciones',
  },
  libro: {
    kicker: 'Ley N.° 29571 · D.S. N.° 011-2011-PCM',
    title: 'Libro de Reclamaciones virtual',
    lead:
      'Registra aquí tu reclamo o queja sobre los servicios de Smile Up. Al enviar el formulario se genera una Hoja de Reclamación con número correlativo, podrás imprimirla y recibirás una copia en tu correo.',
    defsTitle: 'Reclamo y queja',
    reclamo: 'Reclamo',
    queja: 'Queja',
    reclamoDef:
      'Disconformidad relacionada con el bien o servicio prestado (por ejemplo, un tratamiento, cobro o resultado). El proveedor debe responder por escrito en un plazo no mayor a 30 días calendario.',
    quejaDef:
      'Malestar o descontento respecto a la atención al público, que no está vinculado al bien o servicio en sí. No exige un pronunciamiento de fondo.',
    reclamoHint: 'Sobre el tratamiento, cobro o servicio recibido.',
    quejaHint: 'Sobre la atención, tiempos o trato en la clínica.',
    deadlineNote:
      'Un reclamo o queja en este libro no es una denuncia ni inicia un procedimiento sancionador. El proveedor conservará la hoja al menos 2 años.',
    providerTitle: 'Identificación del proveedor',
    provider: 'Razón social / proveedor',
    tradeName: 'Nombre comercial',
    establishment: 'Establecimiento',
    rucPending: 'Completar RUC de la clínica',
    formTitle: 'Hoja de reclamación',
    type: 'Identifica tu solicitud',
    consumer: 'Nombre y apellidos del consumidor',
    document: 'Documento de identidad',
    address: 'Domicilio',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    isMinor: 'El consumidor es menor de edad (se requieren datos del padre, madre o representante).',
    guardianName: 'Nombre del padre, madre o representante',
    guardianAddress: 'Domicilio del representante',
    guardianPhone: 'Teléfono del representante',
    guardianEmail: 'Correo del representante',
    service: 'Identificación del bien o servicio',
    servicePlaceholder: 'Ej. evaluación, brackets, alineadores, control',
    amount: 'Monto reclamado (opcional)',
    amountEmpty: 'No consignado',
    detail: 'Detalle del reclamo o queja',
    request: 'Pedido concreto',
    acceptTerms:
      'Declaro que la información consignada es veraz y estoy conforme con los términos de este reclamo o queja. Esta declaración reemplaza la firma manuscrita en el Libro de Reclamaciones virtual.',
    acceptPrivacy:
      'He leído y acepto el tratamiento de mis datos personales conforme a la Ley N.° 29733, para gestionar esta hoja, contactarme y conservar el registro por el plazo legal.',
    acceptError: 'Debes aceptar los términos de la hoja y la cláusula de datos personales.',
    submit: 'Registrar hoja de reclamación',
    submitting: 'Registrando…',
    submitError: 'No se pudo registrar la hoja. Intenta nuevamente en unos minutos.',
    sheetLabel: 'Constancia',
    sheetTitle: 'Hoja de reclamación registrada',
    sheetNumber: 'Número correlativo',
    idCode: 'Código de identificación',
    submittedAt: 'Fecha y hora de presentación',
    print: 'Imprimir constancia',
    copySent: 'Enviamos una copia de esta hoja a tu correo electrónico.',
    copyFailed:
      'La hoja quedó registrada. No se pudo enviar el correo automático; imprime o guarda esta constancia.',
    notComplaint:
      'Esta hoja no limita otros mecanismos de solución de controversias. Si lo consideras necesario, puedes acudir al INDECOPI (www.indecopi.gob.pe).',
    observations: 'Observaciones y acciones adoptadas por el proveedor',
    observationsHint: 'Espacio reservado para la respuesta o acuerdo de Smile Up.',
    recipient: 'Destinatario de esta constancia: consumidor. El proveedor conserva una copia digital. INDECOPI puede requerir el registro.',
  },
  stickyBook: 'Reservar Cita',
  navMega: {
    ariaLabel: 'Menú principal',
    common: {
      colSite: 'Sitio',
      services: 'Servicios',
      servicesDesc: 'Tratamientos de ortodoncia con el Dr. Paniura en Cusco.',
      about: 'Nosotros',
      aboutDesc: 'Conoce al especialista y su enfoque.',
      contact: 'Ubícanos',
      contactDesc: 'Dirección, horarios y mapa.',
    },
    orthodontics: {
      label: 'ORTODONCIA',
      colTreatments: 'Tratamientos',
      colStart: 'Comienza aquí',
      metalBraces: 'Brackets metálicos',
      metalBracesDesc: 'Ortodoncia fija clásica que recomiendo como especialista.',
      ceramicBraces: 'Brackets estéticos',
      ceramicBracesDesc: 'Discretos y resistentes; el doctor te orienta si son para ti.',
      invisalign: 'Invisalign / Alineadores',
      invisalignDesc: 'Alineadores transparentes con mi seguimiento cercano.',
      kids: 'Ortodoncia infantil',
      kidsDesc: 'Ortopedia maxilar para niños con el especialista.',
      selfLigatingBraces: 'Brackets autoligantes',
      selfLigatingBracesDesc: 'Menos fricción y controles más cómodos con el especialista.',
      retainers: 'Retenedores',
      retainersDesc: 'Te indico cómo conservar tu sonrisa al terminar.',
      miniImplants: 'Microimplantes ortodóncicos',
      miniImplantsDesc: 'Anclaje auxiliar que uso en casos complejos.',
      thirdMolar: 'Cirugía de 3er molar',
      thirdMolarDesc: 'Extracción cuando yo lo indico en tu plan.',
      firstVisit: 'Reserva tu consulta',
      firstVisitDesc: 'Agenda tu cita con el doctor en línea.',
      evaluation: 'Evaluación ortodóncica',
      evaluationDesc: 'El Dr. Paniura valora brackets o alineadores.',
    },
    maxillaryOrtho: {
      label: 'ORTOPEDIA MAXILAR',
      colTreatments: 'Nuestros aparatos',
      klamm: 'Klammt',
      klammDesc: 'Aparatología funcional para guiar el crecimiento maxilar.',
      bimler: 'Bimler',
      bimlerDesc: 'Técnica funcional para corregir hábitos y mordida en crecimiento.',
      planas: 'Planas',
      planasDesc: 'Placas activas para interceptar problemas en la infancia.',
      stockfisch: 'Stockfisch',
      stockfischDesc: 'Aparato funcional para armonizar maxilares en desarrollo.',
      clarkTwinBlock: 'Clark Twin Block',
      clarkTwinBlockDesc: 'Bloques gemelos para avanzar mandíbula y corregir Clase II.',
    },
    drPaniura: {
      label: 'Dr. PANIURA',
      colAbout: 'Conoce al especialista',
      profile: 'Sobre el Dr. Germán Paniura',
      profileDesc: 'Ortodoncia en Cusco con mi enfoque claro.',
      approach: 'Filosofía de tratamiento',
      approachDesc: 'Te explico el diagnóstico sin tecnicismos.',
      invisalign: 'Provider Invisalign',
      invisalignDesc: 'Alineadores con mi seguimiento personal.',
    },
    why: {
      label: 'CLINICA',
      colReasons: '¿Por qué Smile Up?',
      smileUp: 'Ortodoncia en Cusco',
      smileUpDesc: 'Brackets y alineadores con el especialista en Cusco.',
      international: 'Pacientes nacionales e internacionales',
      internationalDesc: 'Ortodoncia niños y adultos con alineadores y tecnología digital.',
      comfort: 'Comodidad y tecnología',
      comfortDesc: 'Plan claro que te explico desde la primera visita.',
      evaluation: 'Evaluación personalizada',
      evaluationDesc: 'Tiempos y opciones reales con el doctor.',
    },
    nextStep: {
      label: 'SIGUIENTE PASO',
      colAction: 'Tu próximo paso',
      book: 'Reserva tu consulta',
      bookDesc: 'Agenda tu cita con el doctor en línea.',
      firstAppt: 'Primera cita',
      firstApptDesc: 'Evaluación ortodóncica inicial conmigo.',
      location: 'Ubicación y Horarios',
      locationDesc: 'Mi consulta: Av. La Cultura 822, Cusco.',
    },
    resources: {
      label: 'RECURSOS',
      colGuides: 'Guías y contenido',
      blog: 'Blog de ortodoncia',
      blogDesc: 'Artículos del especialista en ES/EN.',
      alignersGuide: 'Guía brackets y alineadores',
      alignersGuideDesc: 'Opciones que el doctor explica en Cusco.',
      firstConsult: 'Primera consulta ortodóncica',
      firstConsultDesc: 'Reserva tu evaluación con el Dr. Paniura.',
      emergency: 'Dentista de emergencia (EN)',
      emergencyDesc: 'Atención dental urgente para turistas en Cusco.',
    },
  },
  blog: {
    title: 'Blog de ortodoncia',
    subtitle:
      'Brackets, alineadores, ortopedia maxilar y cuidado de tu tratamiento en Cusco.',
    loading: 'Cargando artículos…',
    searchLabel: 'Buscar por palabras clave',
    searchPlaceholder: 'Ej. brackets, alineadores, Invisalign, retenedores…',
    clearSearch: 'Limpiar búsqueda',
    searchHint:
      'Busca en título, resumen, URL del artículo y texto del contenido. Varias palabras reducen los resultados (todas deben aparecer).',
    noResults: 'Sin resultados. Prueba otras palabras o menos términos.',
    resultsOne: '1 artículo encontrado',
    resultsMany: '{{count}} artículos encontrados',
    readMore: 'Leer artículo',
    editPost: 'Editar post',
    viewPostAria: 'Ver artículo: {{title}}',
    noArticles: 'Aún no hay artículos en español.',
  },
  appointment: {
    slotsBanner: 'Solo unos pocos espacios disponibles para hoy',
    info: 'Reserva el próximo espacio disponible con el Dr. Paniura haciendo clic en «Reservar su espacio».',
    bookTitle: 'Reservar visita con el doctor',
    noFee: 'Sin gastos de reserva',
    bookBtn: 'Reservar su espacio',
  },
  auth: {
    emailRequired: 'El correo es obligatorio.',
    passwordRequired: 'La contraseña es obligatoria.',
    invalidServer: 'Respuesta inválida del servidor. ¿Está corriendo el API? (cd server && npm start)',
    loginError: 'Error al iniciar sesión',
    serverConnect: 'No se pudo conectar con el servidor.',
    serverConnectDev:
      ' No comprueba: terminal con `cd server && npm start` y reinicia `npm start` del front.',
    homeAria: 'Inicio Smile Up',
    heroTitle: 'Tu sonrisa en Cusco empieza con',
    heroHighlight: 'confianza y cuidado',
    heroLead: 'Soy el Dr. Germán Paniura, ortodoncista en Cusco: brackets, alineadores, ortopedia maxilar y retenedores. Te atiendo en español e inglés, seas local o viajero.',
    heroAltClinic: 'Atención dental en clínica',
    heroAltOrtho: 'Paciente con ortodoncia',
    heroAltTeam: 'Equipo Smile Up',
    signInTitle: 'Iniciar sesión',
    signInSubtitle: 'Accede a tus citas y reservas en Smile Up',
    email: 'Correo electrónico',
    password: 'Contraseña',
    signIn: 'Iniciar sesión',
    signInWithGoogle: 'Continuar con Google',
    googleSignInFail: 'No se pudo iniciar sesión con Google.',
    googleSignInUnavailable: 'Inicio con Google no disponible en este momento.',
    forgotPassword: '¿Olvidaste tu contraseña?',
    or: 'o',
    bookWithoutAccount: 'Reservar sin cuenta',
    createAccount: 'Crear cuenta nueva',
    footerHome: 'Inicio',
    footerServices: 'Servicios',
    footerContact: 'Contacto',
    footerBlog: 'Blog',
    footerBookings: 'Reservas',
    footerCopy: 'Smile Up · Cusco, Perú',
    registerTitle: 'Crear cuenta',
    registerSubtitle:
      'Cuenta para Smile Up. Si vas a redactar el blog, usa el código de invitación que te dio la clínica (opcional).',
    fullName: 'Nombre completo',
    namePlaceholder: 'Ej. María López',
    emailPlaceholder: 'tu@correo.com',
    phone: 'Teléfono',
    phonePlaceholder: 'Ej. 987654321',
    phoneHint:
      'Elige el país en la lista (desplázate si no ves el tuyo) y escribe el número sin el prefijo.',
    passwordMin: 'Mínimo 6 caracteres',
    confirmPassword: 'Confirmar contraseña',
    repeatPassword: 'Repite la contraseña',
    blogInvite: 'Código invitación blog (opcional)',
    blogInvitePlaceholder: 'Solo si te asignaron rol editor/admin',
    blogInviteHint:
      'Debe coincidir exactamente con el código de la clínica (mayúsculas o minúsculas valen igual). Si no lo usas, la cuenta será de paciente.',
    createAccountBtn: 'Crear cuenta',
    haveAccount: '¿Ya tienes cuenta?',
    passwordsMismatch: 'La contraseña y la confirmación deben coincidir.',
    nameTooShort: 'Indica tu nombre completo',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
    emailRequiredReg: 'El correo es obligatorio',
    phoneTooShort: 'Ingresa tu número de teléfono (solo dígitos, sin el prefijo).',
    phoneInvalid: 'El teléfono completo no es válido. Revisa país y número.',
    accountAdmin: 'Cuenta creada como administrador del blog.',
    accountEditor: 'Cuenta creada como editor del blog.',
    accountUser: 'Cuenta creada como usuario.',
    noServerResponse: 'No hay respuesta del servidor.',
    registerFailed: 'No se pudo registrar (código {{code}}).',
    backToSignIn: 'Volver al inicio de sesión',
    forgotTitle: '¿Olvidaste tu contraseña?',
    forgotSubtitle: 'Te enviaremos un enlace a tu correo para crear una contraseña nueva.',
    forgotEmailRequired: 'Ingresa tu correo electrónico.',
    forgotSendFail: 'No se pudo enviar el correo.',
    forgotSentOk:
      'Te enviamos un correo con el enlace. Revisa la bandeja de entrada y la carpeta de spam.',
    forgotSmtpWarnTitle: 'No se envió ningún correo:',
    forgotSmtpWarnBody:
      'el servidor no tiene configurado el envío SMTP (correo saliente).',
    forgotSmtpHint:
      'Agrega SMTP_HOST, SMTP_USER y SMTP_PASS en tu archivo .env y reinicia el servidor.',
    forgotSentMaybe:
      'Si el correo está registrado, deberías recibir el enlace en unos minutos. Revisa también spam.',
    forgotDevTitle: 'Enlace directo (desarrollo, sin correo)',
    forgotDevBtn: 'Restablecer contraseña ahora',
    forgotGoSignIn: 'Ir a iniciar sesión',
    forgotSubmit: 'Enviar enlace de restablecimiento',
    resetTitle: 'Nueva contraseña',
    resetChecking: 'Verificando enlace…',
    resetInvalid: 'El enlace no es válido o ha caducado. Solicita uno nuevo.',
    resetRequestNew: 'Solicitar nuevo enlace',
    resetSubtitle: 'Elige una contraseña segura (mínimo 6 caracteres).',
    resetNewPassword: 'Nueva contraseña',
    resetConfirm: 'Confirmar contraseña',
    resetRepeat: 'Repite la contraseña',
    resetSave: 'Guardar contraseña',
    resetMinLength: 'La contraseña debe tener al menos 6 caracteres.',
    resetMismatch: 'Las contraseñas no coinciden.',
    resetFail: 'No se pudo actualizar la contraseña.',
    resetDone: 'Contraseña actualizada. Redirigiendo al inicio de sesión…',
    signInNow: 'Iniciar sesión ahora',
  },
  seo: {
    blogTitle: 'Blog de ortodoncia Cusco | Brackets y alineadores (ES/EN)',
    blogDescription:
      'Guías de ortodoncia en Cusco del Dr. Paniura. Brackets, Invisalign, ortopedia maxilar y cuidado del tratamiento. Artículos en español e inglés.',
    reservasTitle: 'Reservar cita | Smile Up Cusco',
    reservasDescription:
      'Calendario de citas con el Dr. Germán Paniura. Gestiona tu agenda o reserva tu evaluación ortodóncica en Cusco.',
    appointmentTitle: 'Cita con el Dr. Paniura | Ortodoncia Cusco',
    appointmentDescription:
      'Agenda tu evaluación ortodóncica con el especialista en Cusco. Brackets, alineadores y ortopedia maxilar para locales y viajeros.',
    libroTitle: 'Libro de Reclamaciones virtual | Smile Up Cusco',
    libroDescription:
      'Libro de Reclamaciones virtual de Smile Up, conforme a la Ley N.° 29571 y el D.S. N.° 011-2011-PCM. Registra tu reclamo o queja en Cusco.',
  },
  booking: {
    weekdaysShort: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    weekdaysMonth: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
    topbarAria: 'Barra de reservas',
    searchSr: 'Buscar paciente por nombre',
    searchPlaceholder: 'Buscar paciente…',
    clearSearch: 'Limpiar búsqueda',
    searchMatchCount: '{{count}} cita(s) esta semana',
    themeLight: 'Modo claro',
    themeDark: 'Modo oscuro',
    refresh: 'Actualizar calendario',
    signIn: 'Iniciar sesión',
    signInTitle: 'Iniciar sesión',
    navBookings: 'Reservas',
    freeConsultCta: 'Reservar Cita',
    freeConsultCtaLine1: 'Reservar Cita',
    freeConsultCtaLine2: '',
    navLocation: 'Ubícanos',
    navAria: 'Navegación de reservas',
    labelSchedule: 'Horario',
    labelFirstName: 'Nombre',
    labelLastName: 'Apellido',
    signInToSee: 'para ver tus fechas reservadas.',
    labelEmail: 'Correo',
    labelPhone: 'Teléfono',
    labelMobilePhone: 'Teléfono celular',
    labelAppointment: 'Cita',
    labelTreatment: 'Tratamiento',
    labelMessage: 'Mensaje',
    messagePh: 'Motivo de la consulta, preferencias o dudas…',
    labelFullName: 'Nombre y apellido',
    labelDocumentType: 'Tipo de documento',
    labelDocumentNumber: 'Número de documento',
    labelClinicLocation: 'Sede',
    selectLocation: 'Elige una',
    labelDate: 'Fecha',
    labelTime: 'Hora',
    labelDuration: 'Duración',
    duration30: '30 minutos',
    duration60: '1 hora',
    durationDecrease: 'Reducir 30 minutos',
    durationIncrease: 'Aumentar 30 minutos',
    durationUnavailable: 'No hay espacio para 1 hora en este horario.',
    durationUpdated: 'Duración de la cita actualizada',
    durationEditTitle: 'Duración de tu cita',
    myApptsTitle: 'Tus fechas reservadas',
    expandMyAppts: 'Ver tus fechas reservadas',
    collapseMyAppts: 'Ocultar tus fechas reservadas',
    noAppointments: 'Aún no tienes fechas reservadas.',
    noSearchMatch: 'Ninguna cita coincide con la búsqueda.',
    deleteAppointment: 'Eliminar cita',
    deleteBtn: 'Eliminar',
    emailInvalid: 'Introduce un correo electrónico válido.',
    confirmTitle: 'Reservar cita',
    confirmSubtitle: 'Completa tus datos para confirmar tu cita.',
    confirmCardIntro:
      'Completa el formulario y pulsa “Enviar solicitud” para que tus datos lleguen por correo electrónico a nuestro equipo.',
    confirmArrivalNote: 'Recuerda llegar minutos antes de tu cita, con todos tus documentos',
    bookModalIntro: 'Completa tus datos y continúa para elegir día y hora disponible.',
    bookModalContinue: 'Elegir horario',
    bookModalCancel: 'Cancelar',
    bookModalClose: 'Cerrar',
    fieldRequired: 'Falta completar este campo.',
    privacyAcceptedPrefix: 'He leído y acepto la',
    privacyClauseTitle: 'Cláusula Informativa de Protección de Datos',
    privacyClauseBody:
      'De conformidad con la Ley N.° 29733, Ley de Protección de Datos Personales, y su Reglamento aprobado por D.S. N.° 003-2013-JUS, informamos que los datos personales proporcionados en este formulario serán tratados por Smile Up, ubicado en Av. La Cultura 822, Wanchaq, Cusco, con la finalidad de gestionar tu solicitud de reserva enviada por correo electrónico, contactarte por teléfono o correo electrónico, coordinar la atención solicitada y realizar el seguimiento administrativo relacionado con tu cita. Los datos solicitados pueden incluir nombres y apellidos, teléfono, correo electrónico, tipo y número de documento, y la información que voluntariamente indiques. Tus datos serán tratados de forma confidencial y no serán compartidos con terceros, salvo obligación legal o cuando sea necesario para prestar el servicio solicitado. Puedes ejercer tus derechos de acceso, rectificación, cancelación y oposición dirigiéndote al correo clinicasmileupcusco@gmail.com o acercándote a la sede de la clínica.',
    privacyText: 'He leído y acepto la Cláusula Informativa de Protección de Datos',
    privacyRequired: 'Debes aceptar la cláusula informativa.',
    submitReservation: 'Enviar solicitud',
    sending: 'Enviando correo…',
    emailSendSuccess: 'Solicitud enviada por correo. Nuestro equipo se comunicará contigo pronto.',
    emailSendError: 'No se pudo enviar la solicitud por correo. Inténtalo nuevamente.',
    bookedSuccess: 'Cita agendada con éxito',
    slotTaken: 'Este horario ya está reservado. Elige otra fecha u hora.',
    fillRequired: 'Completa nombre, correo, teléfono, fecha y hora.',
    cancelConfirm: '¿Cancelar esta cita y liberar el horario?',
    firstNamePh: 'Ej. María',
    lastNamePh: 'Ej. García',
    calendarHint:
      'En gris: horario reservado (lun–sáb). Clic en celda libre para reservar.',
    refreshLabel: 'Actualizar',
    logout: 'Cerrar sesión',
    accountLabel: 'Mi cuenta',
    accountOf: 'Cuenta de {{name}}',
    navSchedules: 'Horarios',
    navMonth: 'Mes',
    closeMonth: 'Cerrar calendario',
    navProfile: 'Mi perfil',
    navAdmin: 'Admin',
    monthCalendarAria: 'Calendario mensual',
    weekCalendarAria: 'Horarios de reserva',
    monthPickHint: 'Elige un día laborable en el calendario para ver horarios.',
    daySlotsTitle: 'Horarios',
    weekClockAria: 'Hora actual en GMT-05 (Lima)',
  },
};

export const siteContentEn = {
  services: {
    header: 'Our Treatments',
    treatmentUnspecified: 'Treatment not specified',
    bookingTreatments: [
      { id: 'primera-cita', title: 'First visit / Orthodontic evaluation', shortTitle: 'First visit' },
      { id: 'metalBraces', title: 'Metal braces', shortTitle: 'Metal braces' },
      { id: 'ceramicBraces', title: 'Ceramic braces', shortTitle: 'Ceramic braces' },
      { id: 'invisalign', title: 'Invisalign / Aligners', shortTitle: 'Aligners' },
      { id: 'selfLigatingBraces', title: 'Self-ligating braces', shortTitle: 'Self-ligating' },
      { id: 'retainers', title: 'Retainers', shortTitle: 'Retainers' },
      { id: 'miniImplants', title: 'Orthodontic mini-implants (TADs)', shortTitle: 'Mini-implants' },
      { id: 'thirdMolar', title: 'Third molar surgery', shortTitle: '3rd molar' },
    ],
  },
  about: {
    title: 'Orthodontics with Dr. Germán Paniura in Cusco',
    shortDesc:
      'I am Dr. Germán Paniura, orthodontist in Cusco. I lead Smile Up—braces, Invisalign, maxillary orthopedics, retainers and mini-implants—with a clear evaluation from your first visit with me.',
    longDesc:
      'As an orthodontics specialist I provide metal and ceramic braces, Invisalign clear aligners, maxillary orthopedics for children and teens, retainers and mini-implants when your case requires them. I also coordinate third molar surgery when it is part of your plan. In Cusco I assess your bite, facial symmetry and habits; I explain your diagnosis in plain language, options and realistic timelines. My goal is for you to understand every step, move forward comfortably and achieve a harmonious smile with my close follow-up.',
    imageAlt: 'Dr. Germán Paniura — orthodontics in Cusco',
  },
  contact: {
    scheduleTitle: 'Opening hours',
    days: [
      { day: 'Monday', time: '10:00 AM–7:00 PM' },
      { day: 'Tuesday', time: '10:00 AM–7:00 PM' },
      { day: 'Wednesday', time: '10:00 AM–7:00 PM' },
      { day: 'Thursday', time: '10:00 AM–7:00 PM' },
      { day: 'Friday', time: '10:00 AM–7:00 PM' },
      { day: 'Saturday', time: '9:00 AM–2:00 PM' },
    ],
    directions: 'Clinic directions',
    callClinic: 'Call the clinic',
    whatsappCta: 'WhatsApp',
    mapTitle: 'Smile Up clinic map in Cusco',
    socialAria: 'Social media',
  },
  footer: {
    patientTitle: 'Patient area',
    patientSubtitle: 'Access your history and appointments',
    patientLogin: 'Patient session',
    phoneLabel: 'Call:',
    phoneValue: '(084) 607539 - Peru',
    address: 'Av. La Cultura 822, Wanchaq-Cusco',
    seoLinksAria: 'Helpful links',
    emergency: 'Emergency dentist in Cusco',
    libro: 'Complaints book',
  },
  libro: {
    kicker: 'Law No. 29571 · Supreme Decree No. 011-2011-PCM',
    title: 'Virtual complaints book',
    lead:
      'File a claim or complaint about Smile Up services. Submitting this form creates a numbered complaint sheet you can print; a copy is also emailed to you. The official form is provided in accordance with Peruvian consumer law.',
    defsTitle: 'Claim and complaint',
    reclamo: 'Claim (reclamo)',
    queja: 'Complaint (queja)',
    reclamoDef:
      'A disagreement related to the good or service provided (for example treatment, billing or result). The provider must reply in writing within 30 calendar days.',
    quejaDef:
      'Discomfort with customer service that is not about the good or service itself. It does not require a substantive decision.',
    reclamoHint: 'About treatment, charges or the service received.',
    quejaHint: 'About wait times, service or how you were treated.',
    deadlineNote:
      'A claim or complaint in this book is not a report to INDECOPI and does not start a sanctioning procedure. The provider keeps the sheet for at least 2 years.',
    providerTitle: 'Provider identification',
    provider: 'Legal name / provider',
    tradeName: 'Trade name',
    establishment: 'Establishment',
    rucPending: 'Clinic RUC to be completed',
    formTitle: 'Complaint sheet',
    type: 'Identify your request',
    consumer: 'Consumer full name',
    document: 'Identity document',
    address: 'Address',
    email: 'Email',
    phone: 'Phone',
    isMinor: 'The consumer is a minor (parent or guardian details are required).',
    guardianName: 'Parent or guardian name',
    guardianAddress: 'Guardian address',
    guardianPhone: 'Guardian phone',
    guardianEmail: 'Guardian email',
    service: 'Good or service identification',
    servicePlaceholder: 'E.g. evaluation, braces, aligners, follow-up',
    amount: 'Claimed amount (optional)',
    amountEmpty: 'Not provided',
    detail: 'Details of the claim or complaint',
    request: 'Specific request',
    acceptTerms:
      'I declare that the information provided is true and I agree with the terms of this claim or complaint. This declaration replaces a handwritten signature on the virtual complaints book.',
    acceptPrivacy:
      'I have read and accept the processing of my personal data under Peruvian Law No. 29733, to manage this sheet, contact me and keep the record for the legal retention period.',
    acceptError: 'You must accept the sheet terms and the personal-data clause.',
    submit: 'Submit complaint sheet',
    submitting: 'Submitting…',
    submitError: 'The sheet could not be registered. Please try again in a few minutes.',
    sheetLabel: 'Receipt',
    sheetTitle: 'Complaint sheet registered',
    sheetNumber: 'Sequential number',
    idCode: 'Identification code',
    submittedAt: 'Date and time of filing',
    print: 'Print receipt',
    copySent: 'A copy of this sheet was sent to your email.',
    copyFailed:
      'The sheet was registered. The automatic email could not be sent; please print or save this receipt.',
    notComplaint:
      'This sheet does not limit other dispute-resolution options. You may contact INDECOPI if needed (www.indecopi.gob.pe).',
    observations: 'Provider observations and actions taken',
    observationsHint: 'Reserved for Smile Up’s written response or settlement.',
    recipient:
      'Recipient of this receipt: consumer. The provider keeps a digital copy. INDECOPI may request the record.',
  },
  stickyBook: 'Book Appointment',
  navMega: {
    ariaLabel: 'Main menu',
    common: {
      colSite: 'Site',
      services: 'Services',
      servicesDesc: 'Orthodontic treatments with Dr. Paniura in Cusco.',
      about: 'About us',
      aboutDesc: 'Meet the specialist and his approach.',
      contact: 'Location',
      contactDesc: 'Address, hours and map.',
    },
    orthodontics: {
      label: 'ORTHODONTICS',
      colTreatments: 'Treatments',
      colStart: 'Get started',
      metalBraces: 'Metal braces',
      metalBracesDesc: 'Classic fixed orthodontics I recommend as a specialist.',
      ceramicBraces: 'Ceramic braces',
      ceramicBracesDesc: 'Discreet and durable; the doctor guides you if they fit your case.',
      invisalign: 'Invisalign / Aligners',
      invisalignDesc: 'Clear aligners with my close follow-up.',
      kids: 'Children\'s orthodontics',
      kidsDesc: 'Maxillary orthopedics for children with the specialist.',
      selfLigatingBraces: 'Self-ligating braces',
      selfLigatingBracesDesc: 'Less friction and more comfortable check-ups with the specialist.',
      retainers: 'Retainers',
      retainersDesc: 'I tell you how to preserve your smile after treatment.',
      miniImplants: 'Orthodontic mini-implants',
      miniImplantsDesc: 'Auxiliary anchorage I use in complex cases.',
      thirdMolar: 'Third molar surgery',
      thirdMolarDesc: 'Extraction when I indicate it in your plan.',
      firstVisit: 'Book your consultation',
      firstVisitDesc: 'Schedule your appointment with the doctor online.',
      evaluation: 'Orthodontic evaluation',
      evaluationDesc: 'Dr. Paniura assesses braces or aligners.',
    },
    maxillaryOrtho: {
      label: 'MAXILLARY ORTHOPEDICS',
      colTreatments: 'Our appliances',
      klamm: 'Klammt',
      klammDesc: 'Functional appliance to guide maxillary growth.',
      bimler: 'Bimler',
      bimlerDesc: 'Functional technique to correct habits and bite during growth.',
      planas: 'Planas',
      planasDesc: 'Active plates to intercept problems in childhood.',
      stockfisch: 'Stockfisch',
      stockfischDesc: 'Functional appliance to harmonize developing jaws.',
      clarkTwinBlock: 'Clark Twin Block',
      clarkTwinBlockDesc: 'Twin blocks to advance the mandible and correct Class II.',
    },
    drPaniura: {
      label: 'Dr. PANIURA',
      colAbout: 'Meet the specialist',
      profile: 'About Dr. Germán Paniura',
      profileDesc: 'Clear orthodontics in Cusco with my approach.',
      approach: 'Treatment philosophy',
      approachDesc: 'I explain your diagnosis without jargon.',
      invisalign: 'Invisalign provider',
      invisalignDesc: 'Aligners with my personal follow-up.',
    },
    why: {
      label: 'CLINIC',
      colReasons: 'Why Smile Up?',
      smileUp: 'Orthodontics in Cusco',
      smileUpDesc: 'Braces and aligners with the specialist in Cusco.',
      international: 'National and international patients',
      internationalDesc: 'Orthodontics for children and adults with aligners and digital tech.',
      comfort: 'Comfort and technology',
      comfortDesc: 'Clear plan I explain from the first visit.',
      evaluation: 'Personalized evaluation',
      evaluationDesc: 'Real timelines and options with the doctor.',
    },
    nextStep: {
      label: 'NEXT STEP',
      colAction: 'Your next step',
      book: 'Book your consultation',
      bookDesc: 'Schedule your appointment with the doctor online.',
      firstAppt: 'First appointment',
      firstApptDesc: 'Initial orthodontic evaluation with me.',
      location: 'Location and Hours',
      locationDesc: 'My practice: Av. La Cultura 822, Cusco.',
    },
    resources: {
      label: 'RESOURCES',
      colGuides: 'Guides and content',
      blog: 'Orthodontics blog',
      blogDesc: 'Articles by the specialist in ES/EN.',
      alignersGuide: 'Braces & aligners guide',
      alignersGuideDesc: 'Options the doctor explains in Cusco.',
      firstConsult: 'First orthodontic consultation',
      firstConsultDesc: 'Book your evaluation with Dr. Paniura.',
      emergency: 'Emergency dentist in Cusco',
      emergencyDesc: 'Same-day dental care for tourists in Cusco.',
    },
  },
  blog: {
    title: 'Orthodontics blog',
    subtitle:
      'Braces, aligners, maxillary orthopedics and treatment care in Cusco.',
    loading: 'Loading articles…',
    searchLabel: 'Search by keywords',
    searchPlaceholder: 'e.g. braces, aligners, Invisalign, retainers…',
    clearSearch: 'Clear search',
    searchHint:
      'Searches title, excerpt, article URL and body text. Multiple words narrow results (all must match).',
    noResults: 'No results. Try other words or fewer terms.',
    resultsOne: '1 article found',
    resultsMany: '{{count}} articles found',
    readMore: 'Read article',
    editPost: 'Edit post',
    viewPostAria: 'View article: {{title}}',
    noArticles: 'No English articles yet. Switch to ES or check back soon.',
  },
  appointment: {
    slotsBanner: 'Only a few slots left for today',
    info: 'Book the next available slot with Dr. Paniura by clicking «Book your slot».',
    bookTitle: 'Book a visit with the doctor',
    noFee: 'No booking fee',
    bookBtn: 'Book your slot',
  },
  auth: {
    emailRequired: 'Email is required.',
    passwordRequired: 'Password is required.',
    invalidServer: 'Invalid server response. Is the API running? (cd server && npm start)',
    loginError: 'Sign-in failed',
    serverConnect: 'Could not connect to the server.',
    serverConnectDev:
      ' Check: API terminal with `cd server && npm start` and restart the frontend `npm start`.',
    homeAria: 'Smile Up home',
    heroTitle: 'Your smile in Cusco starts with',
    heroHighlight: 'trust and care',
    heroLead: 'I am Dr. Germán Paniura, orthodontist in Cusco: braces, aligners, maxillary orthopedics and retainers. I care for you in English and Spanish, whether you are local or visiting.',
    heroAltClinic: 'Dental care at the clinic',
    heroAltOrtho: 'Patient with braces',
    heroAltTeam: 'Smile Up team',
    signInTitle: 'Sign in',
    signInSubtitle: 'Access your appointments and bookings at Smile Up',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    signInWithGoogle: 'Continue with Google',
    googleSignInFail: 'Could not sign in with Google.',
    googleSignInUnavailable: 'Google sign-in is not available right now.',
    forgotPassword: 'Forgot your password?',
    or: 'or',
    bookWithoutAccount: 'Book without an account',
    createAccount: 'Create new account',
    footerHome: 'Home',
    footerServices: 'Services',
    footerContact: 'Contact',
    footerBlog: 'Blog',
    footerBookings: 'Bookings',
    footerCopy: 'Smile Up · Cusco, Peru',
    registerTitle: 'Create account',
    registerSubtitle:
      'Smile Up account. If you will write for the blog, use the invite code from the clinic (optional).',
    fullName: 'Full name',
    namePlaceholder: 'e.g. Jane Smith',
    emailPlaceholder: 'you@email.com',
    phone: 'Phone',
    phonePlaceholder: 'e.g. 987654321',
    phoneHint: 'Choose your country and enter the number without the country code.',
    passwordMin: 'At least 6 characters',
    confirmPassword: 'Confirm password',
    repeatPassword: 'Repeat password',
    blogInvite: 'Blog invite code (optional)',
    blogInvitePlaceholder: 'Only if assigned editor/admin role',
    blogInviteHint:
      'Must match the clinic code exactly (case insensitive). Without it, you get a patient account.',
    createAccountBtn: 'Create account',
    haveAccount: 'Already have an account?',
    passwordsMismatch: 'Password and confirmation must match.',
    nameTooShort: 'Enter your full name',
    passwordTooShort: 'Password must be at least 6 characters',
    emailRequiredReg: 'Email is required',
    phoneTooShort: 'Enter your phone number (digits only, without country code).',
    phoneInvalid: 'Full phone number is invalid. Check country and number.',
    accountAdmin: 'Account created as blog administrator.',
    accountEditor: 'Account created as blog editor.',
    accountUser: 'Account created successfully.',
    noServerResponse: 'No response from server.',
    registerFailed: 'Registration failed (code {{code}}).',
    backToSignIn: 'Back to sign in',
    forgotTitle: 'Forgot your password?',
    forgotSubtitle: 'We will email you a link to set a new password.',
    forgotEmailRequired: 'Enter your email.',
    forgotSendFail: 'Could not send email.',
    forgotSentOk: 'We sent you an email with the link. Check inbox and spam.',
    forgotSmtpWarnTitle: 'No email was sent:',
    forgotSmtpWarnBody: 'the server has no outgoing SMTP configured.',
    forgotSmtpHint: 'Add SMTP_HOST, SMTP_USER and SMTP_PASS to .env and restart the server.',
    forgotSentMaybe:
      'If the email is registered, you should receive the link shortly. Check spam too.',
    forgotDevTitle: 'Direct link (development, no email)',
    forgotDevBtn: 'Reset password now',
    forgotGoSignIn: 'Go to sign in',
    forgotSubmit: 'Send reset link',
    resetTitle: 'New password',
    resetChecking: 'Verifying link…',
    resetInvalid: 'This link is invalid or expired. Request a new one.',
    resetRequestNew: 'Request new link',
    resetSubtitle: 'Choose a secure password (at least 6 characters).',
    resetNewPassword: 'New password',
    resetConfirm: 'Confirm password',
    resetRepeat: 'Repeat password',
    resetSave: 'Save password',
    resetMinLength: 'Password must be at least 6 characters.',
    resetMismatch: 'Passwords do not match.',
    resetFail: 'Could not update password.',
    resetDone: 'Password updated. Redirecting to sign in…',
    signInNow: 'Sign in now',
  },
  seo: {
    blogTitle: 'Orthodontics Blog Cusco | Braces & Aligners (ES/EN)',
    blogDescription:
      'Orthodontics guides in Cusco by Dr. Paniura. Braces, Invisalign, maxillary orthopedics and treatment care. Articles in Spanish and English.',
    reservasTitle: 'Book appointment | Smile Up Cusco',
    reservasDescription:
      'Appointment calendar with Dr. Germán Paniura. Manage your schedule or book your orthodontic evaluation in Cusco.',
    appointmentTitle: 'Appointment with Dr. Paniura | Orthodontics Cusco',
    appointmentDescription:
      'Book your orthodontic evaluation with the specialist in Cusco. Braces, aligners and maxillary orthopedics for locals and travelers.',
    libroTitle: 'Virtual complaints book | Smile Up Cusco',
    libroDescription:
      'Smile Up virtual complaints book under Peruvian Law No. 29571 and Supreme Decree No. 011-2011-PCM. File a claim or complaint in Cusco.',
  },
  booking: {
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysMonth: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    topbarAria: 'Bookings toolbar',
    searchSr: 'Search patient by name',
    searchPlaceholder: 'Search patient…',
    clearSearch: 'Clear search',
    searchMatchCount: '{{count}} appointment(s) this week',
    themeLight: 'Light mode',
    themeDark: 'Dark mode',
    refresh: 'Refresh calendar',
    signIn: 'Sign in',
    signInTitle: 'Sign in',
    navBookings: 'Bookings',
    freeConsultCta: 'Book Appointment',
    freeConsultCtaLine1: 'Book Appointment',
    freeConsultCtaLine2: '',
    navLocation: 'Location',
    navAria: 'Bookings navigation',
    labelSchedule: 'Time',
    labelFirstName: 'First name',
    labelLastName: 'Last name',
    signInToSee: 'to see your booked dates.',
    labelEmail: 'Email',
    labelPhone: 'Phone',
    labelMobilePhone: 'Mobile phone',
    labelAppointment: 'Appointment',
    labelTreatment: 'Treatment',
    labelMessage: 'Message',
    messagePh: 'Reason for visit, preferences or questions…',
    labelFullName: 'Full name',
    labelDocumentType: 'Document type',
    labelDocumentNumber: 'Document number',
    labelClinicLocation: 'Location',
    selectLocation: 'Choose one',
    labelDate: 'Date',
    labelTime: 'Time',
    labelDuration: 'Duration',
    duration30: '30 minutes',
    duration60: '1 hour',
    durationDecrease: 'Reduce by 30 minutes',
    durationIncrease: 'Add 30 minutes',
    durationUnavailable: 'There is not enough room for 1 hour at this time.',
    durationUpdated: 'Appointment duration updated',
    durationEditTitle: 'Your appointment duration',
    myApptsTitle: 'Your booked dates',
    expandMyAppts: 'Show your booked dates',
    collapseMyAppts: 'Hide your booked dates',
    noAppointments: 'You have no bookings yet.',
    noSearchMatch: 'No appointment matches your search.',
    deleteAppointment: 'Delete appointment',
    deleteBtn: 'Delete',
    emailInvalid: 'Enter a valid email address.',
    confirmTitle: 'Book appointment',
    confirmSubtitle: 'Complete your details to confirm your appointment.',
    confirmCardIntro:
      'Complete the form and click “Send request” so your details are emailed to our team.',
    confirmArrivalNote: 'Please arrive 10 minutes before your appointment with your documents',
    bookModalIntro: 'Fill in your details and continue to choose an available date and time.',
    bookModalContinue: 'Choose time slot',
    bookModalCancel: 'Cancel',
    bookModalClose: 'Close',
    fieldRequired: 'This field is required.',
    privacyAcceptedPrefix: 'I have read and accept the',
    privacyClauseTitle: 'Data Protection Information Clause',
    privacyClauseBody:
      'In accordance with Peruvian Law No. 29733, Personal Data Protection Law, and its Regulation approved by Supreme Decree No. 003-2013-JUS, we inform you that the personal data provided in this form will be processed by Smile Up, located at Av. La Cultura 822, Wanchaq, Cusco, for the purpose of managing your appointment request sent by email, contacting you by phone or email, coordinating the requested care and carrying out administrative follow-up related to your appointment. The data requested may include full name, phone number, email address, document type and number, and any information you voluntarily provide. Your data will be treated confidentially and will not be shared with third parties except by legal obligation or when necessary to provide the requested service. You may exercise your rights of access, rectification, cancellation and opposition by writing to clinicasmileupcusco@gmail.com or visiting the clinic.',
    privacyText: 'I have read and accept the Data Protection Information Clause',
    privacyRequired: 'You must accept the information clause.',
    submitReservation: 'Send request',
    sending: 'Sending email…',
    emailSendSuccess: 'Request sent by email. Our team will contact you soon.',
    emailSendError: 'The request could not be sent by email. Please try again.',
    bookedSuccess: 'Appointment booked successfully',
    slotTaken: 'This slot is already booked. Choose another date or time.',
    fillRequired: 'Complete name, email, phone, date and time.',
    cancelConfirm: 'Cancel this appointment and free the slot?',
    firstNamePh: 'e.g. Jane',
    lastNamePh: 'e.g. Smith',
    calendarHint:
      'Grey: booked slot (Mon–Sat). Click a free cell to book.',
    refreshLabel: 'Refresh',
    logout: 'Sign out',
    accountLabel: 'My account',
    accountOf: 'Account for {{name}}',
    navSchedules: 'Schedule',
    navMonth: 'Month',
    closeMonth: 'Close calendar',
    navProfile: 'My profile',
    navAdmin: 'Admin',
    monthCalendarAria: 'Monthly calendar',
    weekCalendarAria: 'Booking schedule',
    monthPickHint: 'Choose a weekday on the calendar to see available times.',
    daySlotsTitle: 'Available times',
    weekClockAria: 'Current time in GMT-05 (Lima)',
  },
};

export { SERVICE_IMAGES };

export function attachServiceImages(items) {
  return items.map((item) => ({
    ...item,
    img_src: SERVICE_IMAGES[item.id] || '',
    imageIsPhoto: SERVICE_IMAGE_PHOTO_IDS.has(item.id),
  }));
}
